export default __webpack_public_path__ + "static/media/productValues2.5edb4c49.svg";